import * as i0 from '@angular/core';
import { InjectionToken, Injectable, inject, NgModule } from '@angular/core';
import * as i2 from '@spartacus/core';
import { LoginEvent, LogoutEvent, CommandService } from '@spartacus/core';
import { UserAccountChangedEvent, UserAccountFacade, VerificationTokenFacade } from '@spartacus/user/account/root';
import { switchMap } from 'rxjs/operators';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const USER_ACCOUNT_NORMALIZER = new InjectionToken('UserAccountNormalizer');
const USER_ACCOUNT_SERIALIZER = new InjectionToken('UserAccountSerializer');
const VERIFICATION_TOKEN_NORMALIZER = new InjectionToken('VerificationTokenNormalizer');
const LOGIN_FORM_SERIALIZER = new InjectionToken('LoginFormSerializer');

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class UserAccountAdapter {}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class UserAccountConnector {
  constructor(adapter) {
    this.adapter = adapter;
  }
  get(userId) {
    return this.adapter.load(userId);
  }
  createVerificationToken(verificationTokenCreation) {
    return this.adapter.createVerificationToken(verificationTokenCreation);
  }
  static {
    this.ɵfac = function UserAccountConnector_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UserAccountConnector)(i0.ɵɵinject(UserAccountAdapter));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: UserAccountConnector,
      factory: UserAccountConnector.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserAccountConnector, [{
    type: Injectable
  }], () => [{
    type: UserAccountAdapter
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class UserAccountService {
  constructor(userAccountConnector, userIdService, query) {
    this.userAccountConnector = userAccountConnector;
    this.userIdService = userIdService;
    this.query = query;
    this.userQuery = this.query.create(() => this.userIdService.takeUserId(true).pipe(switchMap(userId => this.userAccountConnector.get(userId))), {
      reloadOn: [UserAccountChangedEvent],
      resetOn: [LoginEvent, LogoutEvent]
    });
  }
  /**
   * Returns the user according the userId
   * no use query for userId can change every time
   */
  getById(userId) {
    return this.userAccountConnector.get(userId);
  }
  /**
   * Returns the current user.
   */
  get() {
    return this.userQuery.get();
  }
  static {
    this.ɵfac = function UserAccountService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UserAccountService)(i0.ɵɵinject(UserAccountConnector), i0.ɵɵinject(i2.UserIdService), i0.ɵɵinject(i2.QueryService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: UserAccountService,
      factory: UserAccountService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserAccountService, [{
    type: Injectable
  }], () => [{
    type: UserAccountConnector
  }, {
    type: i2.UserIdService
  }, {
    type: i2.QueryService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class VerificationTokenService {
  constructor() {
    this.connector = inject(UserAccountConnector);
    this.command = inject(CommandService);
    this.createVerificationTokenCommand = this.command.create(({
      verificationTokenCreation
    }) => this.connector.createVerificationToken(verificationTokenCreation));
  }
  /**
   * create verification token
   */
  createVerificationToken(verificationTokenCreation) {
    return this.createVerificationTokenCommand.execute({
      verificationTokenCreation
    });
  }
  static {
    this.ɵfac = function VerificationTokenService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || VerificationTokenService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: VerificationTokenService,
      factory: VerificationTokenService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VerificationTokenService, [{
    type: Injectable
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const facadeProviders = [UserAccountService, {
  provide: UserAccountFacade,
  useExisting: UserAccountService
}, VerificationTokenService, {
  provide: VerificationTokenFacade,
  useExisting: VerificationTokenService
}];

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class UserAccountCoreModule {
  static {
    this.ɵfac = function UserAccountCoreModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UserAccountCoreModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: UserAccountCoreModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [UserAccountConnector, ...facadeProviders]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserAccountCoreModule, [{
    type: NgModule,
    args: [{
      providers: [UserAccountConnector, ...facadeProviders]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LOGIN_FORM_SERIALIZER, USER_ACCOUNT_NORMALIZER, USER_ACCOUNT_SERIALIZER, UserAccountAdapter, UserAccountConnector, UserAccountCoreModule, UserAccountService, VERIFICATION_TOKEN_NORMALIZER, VerificationTokenService };
